<div class="gray-bg-rounded">
  <div
    *ngIf="formArray && formArray.length > 0"
    class="col-lg-12 freight-table-form">
    <table class="table">
      <thead>
        <tr>
          <!-- <th scope="col">LID</th> -->
          <th scope="col">
            <span
              >PACKAGES<br />
              DESC</span
            >
          </th>
          <th scope="col">
            <span>NO. OF PKGS</span> <span class="madatory-field">*</span><br />
            <sub>
              Max.
              <span class="info-thicon hover-button">
                <a><i class="pi pi-info-circle"></i></a>
                <div class="hover-content">
                  {{ getTooltipByKey("max_pkg") }}
                </div>
              </span>
            </sub>
          </th>
          <th scope="col">
            <span>WEIGHT PER PKG</span> <span class="madatory-field">*</span
            ><br />
            <sub>
              Max. Wt:
              <span class="info-thicon hover-button">
                <a><i class="pi pi-info-circle"></i></a>
                <div class="hover-content">
                  {{ getTooltipByKey("max_wt_pound") }}
                </div>
              </span>
            </sub>
          </th>
          <th scope="col">
            <span>DIMENSIONS PER PACKAGES</span>
            <br /><sub>L * W * H (Optional)</sub>
          </th>
          <th scope="col"><span>Total Weight</span></th>
          <th scope="col"><span>$</span></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let package of formArray.controls; let i = index"
          [formGroup]="getFormGroup(i)">
          <!-- <td>
            <div class="hori-input">
                {{ i + 1 }}.
            </div>
        </td> -->
          <td>
            <div class="hori-input">
              <input
                type="text"
                pInputText
                formControlName="packageDescription"
                (input)="onPackageChange()" />
            </div>
          </td>
          <td>
            <div class="hori-input">
              <div class="hori-input">
                <input
                  type="number"
                  min="0"
                  pInputText
                  formControlName="packageCount"
                  (input)="packageWeightChange(package)"
                  [ngClass]="{
                    'error-msg': !package.value.packageCount,
                  }" />
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex gap-2 align-items-center">
              <div class="hori-input">
                <input
                  type="number"
                  min="0"
                  pInputText
                  formControlName="packageWeight"
                  (input)="packageWeightChange(package)"
                  [ngClass]="{
                    'error-msg': !package.value.packageWeight,
                  }" />
              </div>
              <div class="dropdown-hori">
                {{ package.value.weightUnitCode }}
              </div>
            </div>
          </td>
          <td class="">
            <div class="d-flex gap-1 align-items-center">
              <div class="hori-input">
                <input
                  type="number"
                  min="0"
                  pInputText
                  formControlName="packageLength"
                  (input)="onPackageChange()" />
              </div>

              <div class="hori-input">
                <input
                  type="number"
                  min="0"
                  pInputText
                  formControlName="packageDepth"
                  (input)="onPackageChange()" />
              </div>

              <div class="hori-input">
                <input
                  type="number"
                  min="0"
                  pInputText
                  formControlName="packageHeight"
                  (input)="onPackageChange()" />
              </div>

              <div class="dropdown-hori">
                {{ package.value.dimentsionUnitCode }}
              </div>
            </div>
          </td>

          <td>
            <div class="hori-input">
              <div class="hori-input mt-2">
                {{ totalWeight(package) }}
              </div>
            </div>
          </td>

          <td>
            <div
              class="hori-input d-flex gap-2 mt-2"
              [style]="{ cursor: 'pointer' }"
              (click)="
                showOrHidePricingModal(estimations, shipmentReferenceId, i)
              ">
              <div
                [innerHtml]="
                  getPackagePricingList(estimations, shipmentReferenceId, i)
                "></div>
            </div>
          </td>
          <td>
            <span (click)="removePackageAt(i)" class="mt-2 d-block">
              <i class="pi pi-times-circle"></i
            ></span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="col-lg-10">
        <div class="d-flex align-items-center gap-4">
          <a href="javascript:;" (click)="addPackage()"
            >+ Add Another Package</a
          >
          <a
            href="javascript:;"
            *ngIf="currentShipment > 0"
            (click)="removeThisShipment()"
            >- Remove shipment</a
          >
        </div>
      </div>
      <div class="col-2">
        <div class="freight-btn02 mb-1">
          <p-button
            (onClick)="clearPackages()"
            label="Clear All Packages"></p-button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog
  [position]="'center'"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showPricingDetailDialog"
  [closable]="true"
  [style]="{
    width: '50%',
    height: 'auto',
    'min-height': '180px',
    'border-radius': '10px',
    overflow: 'visible',
  }"
  appendTo="body">
  <ng-template pTemplate="header">
    <div class="col-lg-10 gap-2 d-flex">
      <h1>Package Price Detail</h1>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p-table
      [value]="selectedPackageModal ?? []"
      #dt
      stripedRows
      [rowHover]="true"
      responsiveLayout="scroll"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th>Description</th>
          <th>Value</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-FreightChargesDetail
        let-rowIndex="rowIndex">
        <tr>
          <td>{{ FreightChargesDetail.pricingDetailDescription }}</td>
          <td>
            {{ FreightChargesDetail.pricingDetailAmount | number: "1.2-2" }}
          </td>
          <td
            [ngClass]="{
              coloured: ['KG', 'LB', 'LBS'].includes(
                FreightChargesDetail.pricingCurrencyCode
              ),
            }">
            {{ FreightChargesDetail.pricingCurrencyCode }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>
<jni-confirm-dialog
  [dialogMessage]="packageClearMessage"
  dialogHeading="Are you sure?"
  *ngIf="clearAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="clearPackagesConfirm($event)">
</jni-confirm-dialog>
